import * as React from 'react';
import {LocalStorage} from './local-storage';
import {SessionEditorCodemirror} from '../codemirror/codemirror';

export interface ISessionEditorCodepadProps {
  editorValue: string;
  initialCode: string;
  latestCode: string;
  updatedAt: string;
  language: string;
  disabled: boolean;
  link: string;

  connectEditor: () => void;
  changeCode: (value: string) => void;
}

export class SessionEditorCodepad extends React.Component<ISessionEditorCodepadProps, any> {
  private codeMirror: any;
  private codeMirrorRef: any;
  private localStorage: LocalStorage;

  public constructor(props: ISessionEditorCodepadProps) {
    super(props);
    this.localStorage = new LocalStorage(props.link);
  }

  public render(): React.ReactElement<any> {
    const {
      initialCode,
      editorValue,
    } = this.props;

    return (
      <SessionEditorCodemirror
        initialCode={initialCode}
        value={editorValue}
        ref={node => this.codeMirrorRef = node}
        onChange={this.changeCode}
      />
    );
  }

  public componentDidMount(): void {
    this.assignCodeMirror(this.props.language, this.latestCode());
    this.props.connectEditor();
  }

  public componentDidUpdate(prevProps: ISessionEditorCodepadProps): void {
    const {
      initialCode,
      link,
    } = prevProps

    if (this.props.link !== link || this.props.initialCode !== initialCode) {
      this.redraw()
    }

    if (this.props.disabled !== prevProps.disabled) {
      this.toggleCodeMirror(this.props.disabled);
    }
  }

  public componentWillUnmount(): void {
    this.codeMirrorRef.destroy();
    this.localStorage = null;
  }

  private assignCodeMirror(language: string, value: string): void {
    this.codeMirrorRef.destroy();
    this.codeMirror = this.codeMirrorRef.define({language, value});
    this.toggleCodeMirror(this.props.disabled);
    this.codeMirrorRef.focusCursor();
  }

  private toggleCodeMirror = (state: boolean): void => {
    if (this.codeMirror) {
      this.codeMirror.setOption('readOnly', state);
    }
  }

  private changeCode = (value: string): void => {
    const {
      initialCode,
      changeCode,
    } = this.props;

    this.localStorage.update(value, initialCode !== value);
    changeCode(value);
  }

  private redraw = (): void => {
    const {language, link} = this.props;

    this.localStorage = new LocalStorage(link);
    this.assignCodeMirror(language, this.latestCode());
  }

  private latestCode = (): string => {
    const {latestCode, updatedAt, initialCode} = this.props;
    const defaultValue = this.localStorage.getContent() || initialCode;

    if (!latestCode || !updatedAt) {
      return defaultValue;
    }

    if (Date.parse(updatedAt) > this.localStorage.getUpdatedAt()) {
      return latestCode;
    }

    return defaultValue;
  }
}
